import { SecureService } from '../../core/services/secure.service';
import { BalanceAlertConfiguration } from '../model/BalanceAlertConfiguration';

export class BalanceAlertService extends SecureService {
  constructor() {
    super({
      baseURL: process.env.VUE_APP_API_URL,
    });
  }

  async getBalanceAlertConfiguration(customerId: string) {
    return (
      await this.client.get<BalanceAlertConfiguration>(`/balance-alert/configuration/${customerId}`)
    ).data;
  }

  async createBookingConfiguration(balanceAlertConfiguration: BalanceAlertConfiguration) {
    return (
      await this.client.post<BalanceAlertConfiguration>(
        `/balance-alert/configuration`,
        balanceAlertConfiguration,
      )
    ).data;
  }

  async updateBookingConfiguration(balanceAlertConfiguration: Partial<BalanceAlertConfiguration>) {
    return (
      await this.client.patch<BalanceAlertConfiguration>(
        `/balance-alert/configuration`,
        balanceAlertConfiguration,
      )
    ).data;
  }

  async deletebalanceAlertConfiguration(customerId: string) {
    return (
      await this.client.delete<BalanceAlertConfiguration>(
        `/balance-alert/configuration/${customerId}`,
      )
    ).data;
  }
}

export const balanceAlertService = new BalanceAlertService();
